<template>
  <div class="form-wrapper contact-form-wrapper">
    <div class="left">
      <div class="header title big normal">Contact Us</div>
      <div class="description desc">
        Feel free to contact us for any questions you <br/>might have! <br/> We are here to help you!
      </div>
    </div>
    <form @submit.prevent="submit" class="contact-form" :class="{submitted: formSubmitted}">
      <template v-if="!formSubmitted">
        <div class="container">
          <div class="title left">
            Application form
          </div>

          <div class="column">
            <input placeholder="*Enter full name" required v-model="name" type="text">
          </div>
          <div class="column">
            <input placeholder="*Company name" v-model="companyName" type="text">
          </div>
          <div class="column">
            <input placeholder="*Enter email" required v-model="email" type="email">
          </div>
          <div class="column">
            <input placeholder="*Enter phone number" required v-model="phone" type="text">
          </div>
          <div class="column">
            <input placeholder="Website (optional)" v-model="website" type="text">
          </div>
          <div class="column">
            <!-- <Select2 required class="select2 single arrow"
                     :options="countryOptions"
                     @select="selectCountry($event)"
                     placeholder="Country"
            /> -->
            <select v-model="country">
              <option disabled selected value="">*Country</option>
              <option v-for="(item, i) in countryOptions" :value="item" :key="i">{{ item.title }}</option>
            </select>
          </div>
          <div class="column">
            <textarea placeholder="*Enter your message" v-model="comment" required name="comment" cols="3" rows="5"></textarea>
          </div>
        </div>
        <div class="bottom">
          <button class="button" type="submit">Submit</button>
        </div>
      </template>
      <div v-else class="success-message">
        Your application successfully submitted!
      </div>
    </form>
  </div>
</template>

<script>
// import Select2 from 'vue3-select2-component';

export default {
  // components: {Select2}
  name: 'ContactForm',
  async mounted() {
    await this.getCountries();
  },
  data: function () {
    return {
      formSubmitted: false,
      name: '',
      companyName: '',
      email: '',
      phone: '',
      industry: '',
      website: '',
      volume: '',
      country: '',
      countryId: '',
      comment: '',
      countryOptions: [],
      countryOptionsId: [],
      industryOptions: [
        "Account Support",
        "Trading and Transactions",
        "Security and Compliance",
        "Technical Support",
        "Customer Service",
        "Regulatory and Legal",
        "Partnerships and Business Inquiries",
        "Education and Resources",
        "Marketing and Promotions",
        "Media and Press",
        "Bug Reports",
        "Other"
      ]
    }
  },
  methods: {
    selectIndustry(event) {
      this.industry = event.text;
    },
    selectVolume(event) {
      this.volume = event.text;
    },
    selectCountry(event) {
      this.country = event.text;
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.countryOptions[i] == event.text) {
          this.countryId = this.countryOptionsId[i];
        }
      }
    },
    getCountries() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
          .then((res) => {
            this.countryOptions = res.data.payload;
          })
          .catch((res) => {
            if(res.response.status === 401) {
              this.$parent.openSignInModal();
            }
          })
    },
    submit() {
      this.$http.post(process.env.VUE_APP_API + 'contact-form', {
        name: this.name,
        company_name: this.companyName,
        email: this.email,
        phone: this.phone,
        website: this.website,
        country: this.country.id,
        comment: this.comment
      })
          .then(({data}) => {
            if (data.status === 'OK') {
              this.formSubmitted = true
            }
          })
          .catch((res) => {
            if(res.response.status === 401) {
              this.$parent.openSignInModal();
            }
          })
    }
  }
}
</script>

<style scoped>

</style>